import { useQuery } from 'urql';
import { DOWNLOAD_FILES_PENDING, GET_LOANS, GET_LOAN_BY_ID, GET_LOAN_BY_OWNER, GET_LOAN_CLOSED_BY_LOAN, GET_LOAN_DOCUMENTS } from './graphql';
import { DownloadFilesPendingQuery, GetLoanByIdQuery, GetLoanByOwnerQuery, GetLoansClosedQuery, GetLoanDocByLoanQuery, GetLoansQuery, QueryDownloadFilesPendingArgs, QueryGetLoanByIdArgs, QueryGetLoanDocByLoanArgs, QueryGetLoansClosedArgs } from 'gql/graphql';
import { UseQueryInterface } from '../../../utils/interfaces/use-query.interface';

export const useGetLoanById = (variables: QueryGetLoanByIdArgs, query?: any) => {
    const [{ data, fetching, error }] = useQuery<GetLoanByIdQuery>({ 
        query: query || GET_LOAN_BY_ID,
        variables
    });
    return { data: data?.GetLoanById, fetching, error };
}

export const useGetLoanByOwner = (variables?: {}, query?: any) => {
    const [{ data, fetching, error }] = useQuery<GetLoanByOwnerQuery>({ 
        query: query || GET_LOAN_BY_OWNER,
        variables
    });
    return { data: data?.GetLoanByOwner, fetching, error };
}

export const useGetLoans = (variables?: { search?: string, page?: number, limit?: number }, query?: any) => {
    const [{ data, fetching, error }, reexecute] = useQuery<GetLoansQuery>({ 
        query: query || GET_LOANS,
        variables: {
          search: variables?.search,
          page: variables?.page || 1,
          limit: variables?.limit || 10,
        }
    });
    return { 
      data: data?.GetLoans?.data || [],
      total: data?.GetLoans?.total || 0,
      page: data?.GetLoans?.page || 1,
      totalPages: data?.GetLoans?.totalPages || 1,
      fetching,
      error,
      reexecute
    };
}

export const useGetLoanDocByLoan = (vars?: UseQueryInterface<QueryGetLoanDocByLoanArgs>) => {
    const [{ data, ...others }, reexecute] = useQuery<GetLoanDocByLoanQuery>({
        query: vars?.query || GET_LOAN_DOCUMENTS,
        ...vars
    });
    return {
        data: data?.GetLoanDocByLoan,
        reexecute,
        ...others
    };
};

export const useGetLoanClosedByLoan = (vars?: UseQueryInterface<QueryGetLoansClosedArgs>) => {
  const [{ data, error }, reexecute] = useQuery<GetLoansClosedQuery>({
      query: vars?.query || GET_LOAN_CLOSED_BY_LOAN,
      ...vars
  });
  return {
      data: data?.GetLoansClosed,
      reexecute,
  };
};

export const useDownloadFilePending = (vars?: UseQueryInterface<QueryDownloadFilesPendingArgs>) => {
    const [{ data, ...others }, reexecute] = useQuery<DownloadFilesPendingQuery>({
        query: vars?.query || DOWNLOAD_FILES_PENDING,
        ...vars
    });
    return {
        data: data?.DownloadFilesPending,
        reexecute,
        ...others
    };
};